<template>
	<div class="meeting-details max-content">
		<div v-if="meeting_id == 286" class="cec-index">
			<div class="kv"></div>
			<div class="buttons">
				<img src="@/assets/images/cec2022/button1.png" @click="skip(1)" />
				<img src="@/assets/images/cec2022/button2.png" @click="skip(2)" />
				<img src="@/assets/images/cec2022/button3.png" @click="skip(3)" />
				<img src="@/assets/images/cec2022/button4.png" @click="skip(4)" />
				<img src="@/assets/images/cec2022/button5.png" style="width: 65%;" @click="skip(5)" />
				<img src="@/assets/images/cec2022/button6.png" @click="skip(6)" />
				<img src="@/assets/images/cec2022/button7.png" @click="skip(7)" />
				<img src="@/assets/images/cec2022/button8.png" @click="skip(8)" />
				<img src="@/assets/images/cec2022/button9.png" @click="skip(9)" />
				<img src="@/assets/images/cec2022/button10.png" @click="skip(10)" />
				<img src="@/assets/images/cec2022/button11.png" @click="skip(11)" />
			</div>
		</div>
		<xibeihui v-else-if="meeting_id == 472"></xibeihui>
		<meeting584 v-else-if="meeting_id==584"></meeting584>
		<meeting596 v-else-if="meeting_id==596"></meeting596>
		<meeting602 v-else-if="meeting_id==602"></meeting602>
		<XVC2025 v-else-if="meeting_id==598"></XVC2025>
		<div v-else>
			<top-image :images="images"></top-image>
			<div class="banner-show">
				<div class="cover">
					<van-swipe :autoplay="3000" indicator-color="white" :show-indicators="false">
						<van-swipe-item v-for="(item, key, index) in swiperImg" :key="index">
							<img :src="item.image" alt="">
						</van-swipe-item>
					</van-swipe>
					<p v-if="show_views" class="views"><van-icon name="eye-o" style="margin-right:5px" />{{ views }}</p>
				</div>
			</div>
			<div v-if="meeting_id == 580" class="fixed_h"></div>
			<div v-if="meetingButton.length != 0">
				<button563 v-if="meeting_id == 563" :meetingButton="meetingButton" :showButtonText="show_button_text">
				</button563>
				<div class="relation" v-else>
					<a :style="{ width: button_rows == 4 && item.icon_type != 2 ? '25%' : (button_rows == 4 && item.icon_type == 2) ? '50%' : (button_rows == 3 && item.icon_type != 2) ? '33.3%' : '66.6%' }"
						v-for="(item, index) in meetingButton" :key="index" href="Javascript:void(0)" title="picname"
						@click="skipLink(item)">
						<img :src="item.icon" alt="">
						<p style="color:black;font-size:0.4rem;" v-if="show_button_text">{{ item.name }}</p>
					</a>
				</div>
			</div>

		</div>
	</div>
</template>
<script>
// import Register from "../../components/Users/Register.vue"
import { MeetingsDetails, MeetingsSchedule, MeetingsPlace, MeetingFollows, MeetingButtons, MeetingsCarousel, companyImages } from '../../../config/interface.js'
import { ImagePreview } from 'vant'    //预览图片   使用的函数调用
import TopImage from '../components/TopImage.vue'
import Xibeihui from '@/pages/xbh2024/index.vue'
import Button563 from '../components/Meeting/Button563.vue'
import Meeting584 from '../Meeting584/index.vue'
import Meeting596 from '../Meeting596/index.vue'
import Meeting602 from '../Meeting602/index.vue'
import XVC2025 from '@/pages/XVC/index598.vue'

export default {
	components: {
		TopImage,
		Xibeihui,
		Button563,
		Meeting584,
		Meeting596,
		Meeting602,
		XVC2025
	},
	props: {
		meeting_id: Number
	},
	data() {
		return {
			meetingInfo: {},   //会议信息
			meetingButton: [],    //会议按钮
			swiperImg: {},     //轮播图
			button_rows: 3,     //menu一行按钮数量
			show_button_text: 0, //是否显示按钮名称文字
			loading: false,
			active: 0,
			meetingSchedule: [],
			images: [],
			meeting_name: '',
			show_views: 0,
			views: 0
		}
	},
	beforeRouteEnter(to, from, next) {
		//  修复iOS版微信HTML5 History兼容性问题
		if (to.path !== location.pathname) {

			location.assign(to.fullPath)
		} else {
			next()
		}
	},
	mounted() {
		// this.meeting_id=this.$route.query.meeting_id;
		this.getMeetingDetails(this.meeting_id);
		this.getMeetingButtons(this.meeting_id);
		// this.getSchedule();
		this.getMeetingCarousel();
		this.getImages();
		if (common.is_weixin()) {
			this.showCollect = true;
		}
	},
	methods: {
		getImages() {
			const url = companyImages;
			let params = {
				meeting_id: this.meeting_id,
			}
			const method = "POST";
			fetch(url, params, method)
				.then((res) => {
					if (res.code == 0) {
						this.images = res.data;
					}
				})
		},
		getSchedule() {
			const url = MeetingsSchedule;
			let params = {
				meeting_id: this.meeting_id,
				from_index: 1

			}
			const method = "POST";
			fetch(url, params, method)
				.then((res) => {
					if (res.code == 0) {
						var data = res.data;
						this.meetingSchedule = data.sessions;
						this.scheduleDate = Object.keys(this.meetingSchedule);
					}
				})
		},
		//跳转链接
		skipLink(item) {
			if (item.url.match(/\.(jpeg|jpg|gif|png)$/)) {
				ImagePreview({
					images: [item.url],
					closeable: true,
					showIndex: false
				});
			} else {
				window.location.href = item.url;
			}

		},
		//会议轮播
		getMeetingCarousel() {
			const url = MeetingsCarousel;
			let params = {
				meeting_id: this.meeting_id
			}
			const method = 'POST';
			fetch(url, params, method)
				.then((res) => {
					if (res.code == 0) {
						let data = res.data;
						this.swiperImg = data;
					}
				})
		},
		clickSwiperImg(item) {
			window.location.href = item.link;
		},
		//会议详情
		getMeetingDetails(id) {
			this.$store.dispatch('isShowLoading', true);
			const url = MeetingsDetails;
			const method = 'POST';
			let params = {
				meeting_id: id
			}
			fetch(url, params, method)
				.then((res) => {
					if (res.code == 0) {
						let data = res.data;
						this.button_rows = data.button_rows || 3;
						this.show_button_text = data.show_button_text;
						this.meeting_name = data.name;
						this.show_views = data.show_views
						this.views = data.views
					}
					this.$store.dispatch('isShowLoading', false);
				})
		},
		//会议按钮
		getMeetingButtons(id) {
			const url = MeetingButtons;
			const method = 'POST';
			let params = {
				meeting_id: id
			};
			fetch(url, params, method)
				.then((res) => {
					if (res.code == 0) {
						let data = res.data;
						for (let i in data) {
							var obj = {
								url: data[i].url,
								name: data[i].name,
								icon: data[i].icon,
								icon_type: data[i].icon_type
							}
							this.meetingButton.push(obj);
						}
					}
				})
		}
	}
}
</script>
<style lang="scss" scoped>
.meeting-details {
	overflow: hidden;

	.banner-show {
		width: 100%;

		.cover {
			width: 100%;
			position: relative;

			// margin-bottom:14px;
			img {
				width: 100%;
			}
		}
	}

	.relation {
		overflow: auto;
		padding: .3rem .3rem 0 .3rem;
		@include flex(row);
		align-items: center;
		flex-wrap: wrap;

		div {
			text-align: center;
		}

		a {
			box-sizing: border-box;
			text-align: center;
			padding: .15rem .15rem;
			margin-bottom: 0;
		}

		img {
			background: white;
			border-radius: 10px;
			width: 100%;
			height: 100%;

		}
	}

}

.cec-index {
	background-image: url(../../../assets/images/cec2022/index_bg.png);
	background-size: 100% 100%;
	padding-bottom: 2rem;
}

.cec-index .kv {
	height: 6rem;
}

.cec-index .buttons {
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
	margin: 0 5%;
}

.cec-index .buttons img {
	width: 30%;
	margin: 10px 0;
}

.views {
	text-align: right;
	color: #ffffff;
	background-image: linear-gradient(180deg, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.5));
	line-height: 30px;
	height: 30px;
	position: absolute;
	width: 100%;
	bottom: 5px;
	padding: 0 10px;
}

.fixed_h {
	height: 31.5vh;
}

@media screen and (min-width: 550px) {
	.fixed_h {
		height: 340px;
	}
}
</style>


// WEBPACK FOOTER //
// src/pages/VascularSystem/Index/Details.vue